<template>
    <!-- 步骤导航按钮 -->
    <div class="step-navigation mt24" :style="fixedStyle">
        <el-button
            @click="handlePrevStep"
            :loading="prevStepLoading"
            v-if="showPrevStep"
        >
            上一步
        </el-button>
        <el-button @click="handleWithdrawBtn" v-if="withdrawBtnText" :loading="withdrawBtnLoading">
            {{ withdrawBtnText }}
        </el-button>
        <!-- 发起签署 -->
        <el-button
            type="primary"
            @click="handleSignBtn"
            :loading="signBtnLoading"
            v-if="signBtnText"
        >
            {{ signBtnText }}
        </el-button>

    </div>
</template>


<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { miniStore } from '@/miniStore'
import { getRentOrderConfig, checkOrderBack } from '@/api/purchaseAndSaleAPI/index.js'
import { useSignButton, useWithdrawButton, setOnRefreshCallback } from '../hooks'
import { useFixedBottomBar } from '@/utils/useUtils.js'

import { useOrderDetail } from '@/pages/orders_new/hooks'
import { SIGN_STATUS_ENUM } from '../config'
import { quick } from '@/utils/ba'
import { trackClick } from '@/utils/trackReport'

const { queryAndSetDetail } = useOrderDetail()

const emits = defineEmits(['updateSignStatus'])

const props = defineProps({
  validateForm: Function, // 父组件校验表单函数
})

const { validateForm } = props

const prevStepLoading = ref(false)

const { label: signBtnText,
  handler: signBtnHandle,
  loading: signBtnLoading } = useSignButton(validateForm)

const { label: withdrawBtnText,
  handler: withdrawBtnHandle,
  loading: withdrawBtnLoading } = useWithdrawButton()


const handleSignBtn = () => {
  signBtnHandle(() => {
    emits('updateSignStatus')
  })
}

const handleWithdrawBtn = () => {
  withdrawBtnHandle(() => {
    emits('updateSignStatus')
  })
}

// 从 store 获取当前步骤
const currentStep = computed(() => miniStore.state.currentStep)

// 是否展示上一步
const showPrevStep = computed(() => {
  const { flowState } = miniStore.state.data.step1
  return flowState === SIGN_STATUS_ENUM.PENDING_INITIATE
})

const { fixedStyle, initFixedBottomBar, destroyFixedBottomBar } = useFixedBottomBar()

onMounted(() => {
  initFixedBottomBar()
  setOnRefreshCallback(() => {
    emits('updateSignStatus')
  })
})

onUnmounted(() => {
  destroyFixedBottomBar()
})


// 步骤导航方法(上一步)
const handlePrevStep = async () => {
  // 埋点统计曝光次数
  quick('click', 'personal_sign_contract_prev', {
    from: 'step1',
  })
  trackClick('personal_sign_contract_prev', {
    from: 'step1',
  })
  if (prevStepLoading.value) {
    return
  }
  prevStepLoading.value = true
  try {
    const { code: checkCode } = await checkOrderBack({
      orderId: miniStore.state.data.global.orderId,
    })
    if (checkCode === 1) {
      const { code, data } = await getRentOrderConfig({
        orderId: miniStore.state.data.global.orderId,
      })
      if (code === 1) {
        miniStore.dispatch({
          type: 'BATCH_UPDATE_FIELD',
          payload: {
            updates: {
              step0: {
                id: data.id,
                payMode: data.payMode || data.orderConfig?.rentPlanInfo?.payMode,
                rentPeriod: data.rentPeriod || data.orderConfig?.rentPlanInfo?.rentPeriod,
                rentPeriodType: data.rentPeriodType || data.orderConfig?.rentPlanInfo?.rentPeriodType,
                presentDays: data.presentDays,
                contractTemplateId: data.contractTemplateId,
                contractTemplateName: data.contractTemplateName,
                advancePayment: data.advancePayment,
                orderAccruedPlans: data.orderAccruedPlans,
                payPlanFee: data.payPlanFee,
                relatedOrderId: data.relatedOrderId,
                planId: data.planId,
                planName: data.planName || '自定义',
                rentCategory: data.rentCategory,
                storeId: data.storeId,
                storeName: data.storeName,
                plateNo: data.plateNo,
                carId: data.carId,
                modelId: data.modelId,
                seriesId: data.seriesId,
                startDate: data.startDate,
                endDate: data.endDate,
                isEndDateMode: data.endDateMode,
                cityCodes: data.orderConfig?.rentPlanInfo?.cityCodes || [],
                startStopDate: data.endDate ? [data.startDate, data.endDate] : [],
                prevNext: true,
                customerName: data?.customerName || '',
                source: data.source,
              },
            },
          },
        })
        queryAndSetDetail()
        miniStore.dispatch({ type: 'STEP_CHANGE', payload: { index: currentStep.value - 1 } })
      }
    }
  } finally {
    prevStepLoading.value = false
  }
}

</script>

<style lang="scss" scoped>
/* 步骤导航样式 */
.step-navigation {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 0;
  border-top: 1px solid #ebeef5;
  background: #fff;
}
</style>
